export default __webpack_public_path__ + "static/media/cyberteck-kids.28774636.png";